import { complex, rwAttrib } from '../schema-engine';
import { getInteractionType, setInteractionType, getInteractionResult, setInteractionResult,
         getLatency, setLatency, getTimestamp, setTimestamp } from './interaction.actions';
import { getCMIString4000, setCMIString4000, getCMIString250, setCMIString250 } from './cmi-string.actions';

export function interaction() {
  return complex({
    id: rwAttrib(getCMIString4000, setCMIString4000, 'id'),
    type: rwAttrib(getInteractionType, setInteractionType, 'type'),
    description: rwAttrib(getCMIString250, setCMIString250, 'description'),
    learner_response: rwAttrib(getCMIString4000, setCMIString4000, 'learnerResponse'),
    result: rwAttrib(getInteractionResult, setInteractionResult, 'result'),
    latency: rwAttrib(getLatency, setLatency, 'latency'),
    timestamp: rwAttrib(getTimestamp, setTimestamp, 'timestamp')
  });
}
